import * as React from 'react';
import Div from "@jumbo/shared/Div";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CloseIcon from '@mui/icons-material/Close';


const ImageModal = ({ open, setOpen, data = {} }) => {
  const descriptionElementRef = React.useRef(null);

  const [scroll, setScroll] = React.useState('paper');

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      PaperProps={{ sx: { borderRadius: '20px' } }}
    >
      <DialogTitle id="scroll-dialog-title" sx={{ backgroundColor: "#C21B17", color: "#FFFFFF", marginBottom: 0 }}>
        <Div sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Div>
      </DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
        >
          <Typography sx={{ mb: 2 }} justifyContent={"center"} fontSize={12} fontWeight={600} color={"black"}>{data.fileName}</Typography>
          <Div className='dis-flex-center' >
            <img src={data.b64} width="100%" />
          </Div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;